import React, { useEffect } from 'react';
import { Points } from './agent';
import store from './store';
import { pointsLoaded } from './action';
import ResultMap from './partials/result-map';
import { Redirect } from "react-router-dom";
import ResultAside from "./partials/result-aside";
import Pages from './enums/pages';
import { PrevSettings, PrevSettingsContent, PrevSettingsItem } from './components/prevSettings';
import Alert from './components/alert';
import ReactGA from "react-ga4";

const Promise = global.Promise;

export default function PointsResult(props) {
  let aside = null;
  let resultMap = null;
  const [loaded, setLoaded] = React.useState(false);
  const [redirect, setRedirect] = React.useState(areRoverDataComplete() ? (arePointsDataCompleted() ? Pages.PointsResult : Pages.Points) : Pages.Rover);
  const [error, setError] = React.useState(null);
  const [pointsCount] = React.useState(getPoinsCount());

  function areRoverDataComplete() {
    let rover = props.store.getState().rover;
    return rover.length && rover.turningRadius && rover.wheelDistance;
  }

  function arePointsDataCompleted() {
    let trajectoryPoints = props.store.getState().trajectoryPoints;
    return trajectoryPoints.points.length > 0 && trajectoryPoints.start && trajectoryPoints.end;
  }

  function getPoinsCount() {
    let trajectoryPoints = props.store.getState().trajectoryPoints;
    return trajectoryPoints?.points && trajectoryPoints.points.length > 0 ? trajectoryPoints.points.length : 0
  }

  useEffect(() => {
    if (redirect === Pages.PointsResult)
      loadData();
    document.title = "Points Result | Route Planning";    
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname  });
    }, []);

  //rendering section
  if (redirect === Pages.PointsResult) {
    let map;
    let mapLoader;
    let trajectoryPoints = props.store.getState().trajectoryPoints;

    if (loaded) {
      map = <ResultMap
        trajectoryPoints={store.getState().fieldResult.points}
        wheelDistance={props.store.getState().rover.wheelDistance}
        loaded={loaded}
        store={props.store}
        wayPoints={
          [...[trajectoryPoints?.start], ...trajectoryPoints?.points, ...[trajectoryPoints?.end]]
        }
        ref={instance => { resultMap = instance; }}
        linesBetweenPoints={false}
        actualPointCallback={onChangeActualPoint}
      />;
    } else {
      mapLoader = <>
        <ResultMap
          loaded={loaded}
          store={props.store}
          wayPoints={
            [...[trajectoryPoints?.start], ...trajectoryPoints?.points, ...[trajectoryPoints?.end]]
          }
          linesBetweenPoints={true}
        />
      </>;
    }

    let linkItems = [
      { link: Pages.Field, img: "btn-field.png", alt: "Fill a field", name: "Field" },
      { link: Pages.Obstacles, img: "btn-obstacles.png", alt: "Find the best route", name: "Obstacles" }
    ];

    let positionOfRotationAxis = props.store.getState().rover.positionOfRotationAxis;
    let positionOfGnsReceiver = props.store.getState().rover.positionOfGnsReceiver;

    return <>
      {!loaded && !error && <div className="spinner-overlay">
        <div className="spinner-border text-primary  text-brand" role="status" style={{ height: '3rem', width: '3rem' }}>
          <span className="sr-only"> Loading...</span>
        </div>
      </div>}

      {!loaded && error && <div className="spinner-overlay error">
        <div className='spinner-onerror'>
          <i className='icon icon-exclamation-triangle'></i>
          <h4 className='mb-3'>Something went wrong...</h4>
          <button type='button' className='btn btn-secondary' onClick={(e) => { setRedirect(Pages.Points); }}>Try again</button>
        </div>
      </div>}

      {/* [BLOCK] Map   TODO wheel distance*/}
      <div className="interactive-block">
        {loaded ? map : mapLoader}
        <PrevSettings>
          <PrevSettingsContent header={"Rover"} link={Pages.Rover}>
            <PrevSettingsItem name={"Wheel Distance"} value={props.store.getState().rover.wheelDistance} unit={"m"} />
            <PrevSettingsItem name={"Length"} value={props.store.getState().rover.length} unit={"m"} />
            <PrevSettingsItem name={"Turning radius"} value={props.store.getState().rover.turningRadius} unit={"m"} />
            {positionOfRotationAxis && <PrevSettingsItem name={"Position of axis of rotation"} value={positionOfRotationAxis} unit={"m"} />}
            {positionOfGnsReceiver && <PrevSettingsItem name={"Position of GNSS receiver"} value={positionOfGnsReceiver} unit={"m"} />}
          </PrevSettingsContent>
          <PrevSettingsContent header={"Waypoints"} link={Pages.Points}>
            <PrevSettingsItem name={"Num. of waypoints"} value={pointsCount ?? 0} />
          </PrevSettingsContent>
        </PrevSettings>
      </div>
      <ResultAside
        onPlayAnimationClick={onPlayAnimationClick}
        onAnimationStopClick={onAnimationStopClick}
        onResetAnimationClick={onResetAnimationClick}
        linkItems={linkItems}
        loaded={loaded}
        points={store.getState().fieldResult?.points?.points}
        startPoint={props.store.getState()?.trajectoryPoints?.start}
        store={props.store}
        ref={instance => { aside = instance; }}
        clickPointCallback={onClickPointCallback}
        setAnimationSpeed={onSetAnimationSpeed}
      />
      <div className='alerts-container'>
        {error && <Alert onClick={(e) => { setRedirect(Pages.Points); }} variant='danger'>{error}</Alert>}
      </div>
    </>
  }
  else {
    return <Redirect to={redirect} />
  }

  //other functions:
  function loadData() {
    let trajectoryPoints = props.store.getState().trajectoryPoints;

    let rover = props.store.getState().rover;
    Promise.all([Points.getTrajectoryPoints(
      trajectoryPoints,
      rover
    )]).then((values) => {

      if (values[0].error) {
        console.log(values[0].errorDetail);
        setError(`${values[0].error}`);
      }
      else {
        store.dispatch(pointsLoaded({ points: JSON.parse(values[0].points) }));
        setLoaded(true);
        // this.forceUpdate();
      }
    })
      .catch(error => {
        setRedirect(Pages.Page500);
        console.error(error.message);
      });
  }
  function onPlayAnimationClick() {
    resultMap.drawAnimation();
  }
  function onAnimationStopClick() {
    resultMap.pauseAnimation();
  }
  function onResetAnimationClick() {
    resultMap.redrawAnimation();
    if (aside?.actualPointCallback)
      aside.actualPointCallback(0);
  }
  function onSetAnimationSpeed(speed) {
    resultMap.setAnimationSpeed(speed);
  }
  function onClickPointCallback(index) {
    resultMap.clickPointCallback(index);
  }
  function onChangeActualPoint(index) {
    if (aside?.actualPointCallback)
      aside.actualPointCallback(index);
  }
};